export var l = {//lang
    s : {},
    t : {}
};  

l.s.footer = {
    schedule : '课程表',
    courseList : '我的课程',
    course : '课程',
    msgList : '消息',
    center : '我的'
}


//////////////////
// WEBPACK FOOTER
// ./static/lang/zh-CN.js
// module id = J71k
// module chunks = 82